import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box } from '@honda-canada/design-system-react';
import SpecialOfferCard from './SpecialOfferCard';
import getAllTrims from './utils/getAllTrims';
import mapOffersToTrims from './utils/mapOffersToTrims';
import themeStyles from './SpecialOfferCard.styles';
import useFetchAllOffers from './hooks/useFetchAllOffers';
import useFetchAllPaymentsWithOffer from './hooks/useFetchAllPaymentsWithOffer';
import { filterSpecialPaymentOffers, filterTrimsWithValidSpecialOffers } from './utils/filterSpecialOffers';
import { specialOfferCards } from './mock/mockSpecialOfferCards.json';
const OfferCardContainerWrapper = themeStyles.apply(Box, 'OfferCardContainerWrapper');
const SpecialOffers = ({ fields }) => {
    var _a, _b;
    const allTrims = ((_b = (_a = fields.data.value.catalog.fields.models) === null || _a === void 0 ? void 0 : _a[0].items) !== null && _b !== void 0 ? _b : []).flatMap(item => getAllTrims(item));
    console.log('SpecialOffers all trims', allTrims);
    const { data: allOffers, isSuccess: isOffersLoadSuccess, isFetching: isOffersIsFetching, isLoading: isOffersIsLoading, } = useFetchAllOffers(allTrims);
    const isOffersDataLoaded = !isOffersIsLoading && !isOffersIsFetching && isOffersLoadSuccess;
    const trimsWithOffers = useMemo(() => (isOffersDataLoaded ? mapOffersToTrims(allTrims, filterSpecialPaymentOffers(allOffers)) : []), [allTrims, allOffers, isOffersDataLoaded]);
    console.log('Trims with offers', trimsWithOffers);
    const trimsWithSpecialOffers = filterTrimsWithValidSpecialOffers(trimsWithOffers);
    console.log('SpecialOffers trims with offer', trimsWithSpecialOffers);
    // TODO: https://hondaca.atlassian.net/browse/APT-330
    const trimsWithPaymentAndOffers = useFetchAllPaymentsWithOffer(trimsWithSpecialOffers, isOffersLoadSuccess && !!trimsWithSpecialOffers.length);
    console.log('SpecialOffers trims with payment and offers', trimsWithPaymentAndOffers);
    // TODO: convert trimsWithPaymentAndOffers to special offer cards
    // https://hondaca.atlassian.net/browse/APT-333
    const cards = specialOfferCards;
    return (_jsx(OfferCardContainerWrapper, { children: cards.map(card => (_jsx(SpecialOfferCard, { ...card, 
            // TODO: disable loyalty offer for now, https://hondaca.atlassian.net/browse/APT-261
            hasLoyaltyOffer: false }, `${card.modelInformation.modelYear}-${card.modelInformation.modelName}-${card.modelInformation.trimName}`))) }));
};
export default SpecialOffers;
